export default __webpack_public_path__ + "static/media/Group 5142.85e7b85e.svg";